import React from "react";
import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import ExpandableImage from "../../../components/ExpendableImage";

export type DocsSection = {
  label: string;
  content: React.ReactNode;
};

/**<CarouselComponent
          images={[
            {
              img: "/static/img/docs/tieyksikkölaskuri_helppo.png",
              title: "Päänäkymä",
            },
            {
              img: "/static/img/docs/tieyksikkölaskuri.png",
              title: "Tiekunnan tiedot",
            },
          ]}
        /> */

export const sections: DocsSection[] = [
  {
    label: "Käyttöönotto-opas",
    content: (
      <>
        <Typography variant="h5" gutterBottom>
          Tiehoitokunta.fi – Ohjelmiston käyttöönotto
        </Typography>
        <Typography paragraph>
          Tämä pikaopas auttaa sinua ottamaan Tiehoitokunta.fi-ohjelmiston
          käyttöön ja hallitsemaan tiekuntaasi tehokkaasti. Käyttöönotto vie
          vain muutaman minuutin.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Päänäkymä ja navigointi
        </Typography>
        <ul>
          <li>Yläpalkki: Logo, tiekunta-valitsin, profiili-valikko</li>
          <li>Etusivu: Tilastot, viimeisimmät toiminnot, pikavalinnat</li>
          <li>
            Sivupalkki: Etusivu, Osakkaat, Tiet, Kiinteistöt, Laskut, Kokoukset,
            Tiedostot, Talous, Kartta
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          2. Tiekunnan perustiedot
        </Typography>
        <ul>
          <li>Siirry "Tiekunta"-sivulle ja tarkista perustiedot</li>
          <li>
            Päivitä: tiekunnan nimi, yksikkökerroin, maksut, yhteystiedot,
            pankkitiedot (IBAN ja BIC)
          </li>
          <li>Pankkitiedot ovat välttämättömät laskutusta varten</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          3. Osakkaiden ja kiinteistöjen lisääminen
        </Typography>
        <ul>
          <li>
            Osakas: <b>Osakkaat → Lisää osakas</b> → täytä nimi, yhteystiedot,
            laskutustapa
          </li>
          <li>
            Kiinteistö: <b>Kiinteistöt → Lisää kiinteistö</b> → täytä nimi,
            tunnus, omistaja, yksikköjaotus
          </li>
          <li>
            Huomioithan, että voit luoda kiinteistöjä myös karttanäkymästä!
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          4. Tilikausi
        </Typography>
        <ul>
          <li>Siirry Talous → Tilikaudet</li>
          <li>
            Luo tilikausi: alkamispäivä, päättymispäivä, merkitse aktiiviseksi
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          5. Maksuunpanoluettelo ja laskutus
        </Typography>
        <ExpandableImage
          src="/static/img/docs/maksuunpanoluettelo.jpg"
          alt="Päänäkymä"
        />
        <ul>
          <li>
            Siirry <b>Yksiköinti → Maksuunpanoluettelo</b> ja tarkista tiedot
          </li>
          <li>
            Siirry <b>Laskut → Luo maksuunpanoluettelosta</b> → Valitse laskut →
            Toiminnot → Lähetä lasku
          </li>
          <li>Laskun tilat: Luotu, Lähetetty, Muistutus lähetetty, Maksettu</li>
          <li>
            Voit merkitä laskuja maksetuiksi massatoimintona tiliotteen
            perusteella
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          6. Tiedostot ja kokoukset
        </Typography>
        <ul>
          <li>
            Tiedostot: Lataa ja jaa dokumentteja, esikatsele PDF-tiedostoja
          </li>
          <li>
            Kokoukset: Luo kokous, lähetä kutsut sähköpostilla tai kirjeitse,
            seuraa tilaa
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          7. Taloushallinto
        </Typography>
        <ul>
          <li>Talous: Kirjanpito, tilikaudet, raportit ja tositteet</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          8. Tuki ja ongelmatilanteet
        </Typography>
        <ul>
          <li>Sähköposti: asiakaspalvelu@tiehoitokunta.fi</li>
          <li>Puhelin: 040 4473 776</li>
          <li>Kirjautumisongelmat: Tarkista sähköposti, salasana, vahvistus</li>
          <li>Tiekunta ei näy: Varmista jäsenyys ja aktiivinen tiekunta</li>
          <li>
            Laskutus ei onnistu: Tarkista pankkitiedot ja vastaanottajan tiedot
          </li>
          <li>
            Tiedostojen lataus ei onnistu: Tarkista tiedoston koko ja
            kirjautuminen
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          9. Seuraavat askeleet
        </Typography>
        <ul>
          <li>Täydennä osakasrekisteri</li>
          <li>Täydennä kiinteistörekisteri</li>
          <li>Tarkista yksiköinti</li>
          <li>Lähetä ensimmäinen laskuerä</li>
          <li>Lataa tärkeät dokumentit</li>
          <li>Kutsu muut ylläpitäjät</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          🎉 Onnittelut!
        </Typography>
        <Typography paragraph>
          Olet nyt valmis käyttämään Tiehoitokunta.fi-palvelua ja
          digitalisoimaan tiekuntasi hallintoa. Jos sinulla on kysyttävää tai
          kehitysehdotuksia, ota rohkeasti yhteyttä!
        </Typography>
      </>
    ),
  },
  {
    label: "Etusivu",
    content: (
      <>
        <Typography variant="h5" gutterBottom>
          Etusivu – Yleiskatsaus ja navigointi
        </Typography>

        <ExpandableImage src="/static/img/docs/etusivu.jpg" alt="Päänäkymä" />
        <Typography paragraph>
          Etusivu tarjoaa nopean yleiskatsauksen tiekunnan tilanteeseen. Näet
          keskeiset tilastot, tilauksen tilan ja pääset siirtymään eri osioihin
          kuten osakkaat, tiet, kiinteistöt ja kartta. Etusivu toimii myös
          aloituspisteenä uusille käyttäjille opastuskierroksen avulla.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Tervetuloa-näkymä
        </Typography>
        <ul>
          <li>Näet tervehdyksen ja käyttäjän nimen</li>
          <li>
            Mahdollinen ilmoitus päättyneestä tilauksesta ja ohjaus uusimiseen
          </li>
          <li>Opastuskierros käynnistyy automaattisesti uusille käyttäjille</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          2. Tilastot ja pikavalinnat
        </Typography>
        <ul>
          <li>Osakkaat: määrä ja linkki käyttäjähallintaan</li>
          <li>Tiet: määrä ja linkki tieosuuksiin</li>
          <li>Kiinteistöt: määrä ja linkki kiinteistörekisteriin</li>
          <li>Ilmoitukset: määrä ja viestinnän seuranta</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          3. Karttanäkymä
        </Typography>
        <ul>
          <li>Interaktiivinen kartta tiekunnan alueesta</li>
          <li>Näet tieosuudet ja kiinteistöt visuaalisesti</li>
          <li>Klikkaamalla karttaa siirryt tarkempaan näkymään</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          4. Tilausseuranta
        </Typography>

        <ExpandableImage
          src="/static/img/docs/tilausnakyma.jpg"
          alt="Päänäkymä"
        />
        <ul>
          <li>Jos tilaus on päättynyt, näet ilmoituksen</li>
          <li>Linkki tilauksen uusimiseen laskutussivulle</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          5. Asetukset
        </Typography>

        <ExpandableImage src="/static/img/docs/asetukset.jpg" alt="Päänäkymä" />
        <ul>
          <li>
            Käyttäjäkohtaiset asetukset löydät sovelluksen oikeasta yläkulmasta.
          </li>
          <li>
            Asetuksista pystyt muuttamaan käyttäjän perustietoja, kuten
            osoitteen, salasanan tai nimen.
          </li>
        </ul>
      </>
    ),
  },
  {
    label: "Osakkaat",
    content: (
      <>
        <Typography variant="h5" gutterBottom>
          Osakkaat – Rekisterin hallinta ja muokkaus
        </Typography>
        <Typography paragraph>
          Osakkaat-sivulla hallinnoit tiekunnan jäseniä, heidän yhteystietojaan,
          laskutustapaa ja kiinteistöomistuksia. Voit lisätä uusia osakkaita,
          muokata olemassa olevia ja tarkastella heidän kiinteistöjä. Sivulla
          näkyy myös osakaslista, jota voi järjestää eri kenttien mukaan.
        </Typography>

        <ExpandableImage
          src="/static/img/docs/osakkaat_etusivu.jpg"
          alt="Päänäkymä"
        />

        <Typography variant="h6" gutterBottom>
          1. Osakaslista
        </Typography>
        <ul>
          <li>Lista näyttää osakkaiden etunimen, sukunimen ja sähköpostin</li>
          <li>
            Voit järjestää listaa nimen tai sähköpostin mukaan klikkaamalla
            sarakeotsikkoa
          </li>
          <li>
            Toiminnot-sarakkeessa voit tarkastella, muokata tai poistaa
            osakkaita
          </li>
          <li>Poisto vaatii vahvistuksen ja on sallittu vain ylläpitäjille</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          2. Osakkaan lisääminen tai muokkaaminen
        </Typography>

        <ExpandableImage
          src="/static/img/docs/osakkaat_form.jpg"
          alt="Päänäkymä"
        />
        <ul>
          <li>Lisää uusi osakas painamalla "Lisää"-painiketta</li>
          <li>Muokkaa olemassa olevaa osakasta painamalla kynäikonia</li>
          <li>
            Lomakkeessa täytetään nimi, yhteystiedot, osoite ja laskutustapa
          </li>
          <li>Laskutustapa voi olla sähköposti tai postiosoite</li>
          <li>Tiedot tallennetaan painamalla "Tallenna"</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          3. Kiinteistöjen tarkastelu
        </Typography>
        <ul>
          <li>Muokkauslomakkeessa on välilehti "Näytä kiinteistöt"</li>
          <li>Välilehdellä näkyvät osakkaalle liitetyt kiinteistöt</li>
          <li>Kiinteistöt listataan nimellä ja tunnuksella</li>
          <li>Jos osakkaalla ei ole kiinteistöjä, näytetään ilmoitus</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          4. Ilmoitukset ja palaute
        </Typography>
        <ul>
          <li>Toiminnoista näytetään onnistumis- tai virheilmoitus</li>
          <li>
            Ilmoitukset näkyvät sivun alareunassa ja sulkeutuvat automaattisesti
          </li>
          <li>Poistossa ja tallennuksessa näytetään edistymispalkki</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          5. Navigointi ja käyttöoikeudet
        </Typography>
        <ul>
          <li>Sivulla näkyy murupolku: Etusivu → Osakkaat</li>
          <li>
            Poistaminen on sallittu vain käyttäjille, joilla on ADMIN-roolit
          </li>
          <li>Kaikki toiminnot sidottu aktiiviseen tiekuntaan</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          ✅ Vinkki!
        </Typography>
        <Typography paragraph>
          Pidä osakasrekisteri ajan tasalla, jotta laskutus ja viestintä sujuvat
          ongelmitta. Muista tarkistaa yhteystiedot ennen laskujen lähetystä!
        </Typography>
      </>
    ),
  },
  {
    label: "Tiet",
    content: (
      <>
        <Typography variant="h5" gutterBottom>
          Tieosuuden lisääminen tai muokkaaminen
        </Typography>

        <ExpandableImage src="/static/img/docs/tiet_form.jpg" alt="Päänäkymä" />
        <Typography paragraph>
          Tie -lomakkeella voit lisätä uuden tieosuuden tai muokata olemassa
          olevan tiedot. Tiedot kuten nimi ja kunta ovat tärkeitä yksiköinnin ja
          kunnossapidon suunnittelun kannalta. Voit käyttää joko lomakenäkymää
          tai karttapohjaista lisäystä.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Lomakenäkymä
        </Typography>
        <ul>
          <li>Valitse välilehti "Lisää lomakkeella" tai "Muokkaa tietä"</li>
          <li>Täytä tieosuuden nimi ja kunta</li>
          <li>
            Syötteet validoidaan automaattisesti – virheviesti näkyy
            tarvittaessa
          </li>
          <li>
            Jos tie on sama kuin tiekunnan ensimmäinen tie, sille ei aseteta
            vanhempaa
          </li>
          <li>Painamalla "Tallenna" tiedot tallennetaan ja lomake sulkeutuu</li>
          <li>Painamalla "Peruuta" lomake sulkeutuu ilman tallennusta</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          2. Karttanäkymä
        </Typography>

        <ExpandableImage
          src="/static/img/docs/tiet_kartta.jpg"
          alt="Päänäkymä"
        />
        <ul>
          <li>Valitse välilehti "Lisää kartasta" tai "Näytä kartalla"</li>
          <li>Kartalla näkyvät tiekunnan tieosuudet</li>
          <li>Voit tarkastella tai lisätä tieosuuksia visuaalisesti</li>
          <li>
            Karttatoiminnot tukevat yksiköinnin ja tieyhteyksien hahmottamista
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          3. Validointi ja virheiden tarkistus
        </Typography>
        <ul>
          <li>Nimi ja kunta validoidaan automaattisesti viiveellä</li>
          <li>
            Virheviesti näkyy, jos tie on jo olemassa tai tiedot puuttuvat
          </li>
          <li>
            Validointi tapahtuu kun syötteet ovat vähintään 3 merkkiä pitkiä
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          ✅ Vinkki!
        </Typography>
        <Typography paragraph>
          Käytä karttanäkymää, jos haluat varmistaa tieosuuden sijainnin tai
          visuaalisen yhteyden kiinteistöihin. Muista tarkistaa, ettei tie ole
          jo olemassa samassa kunnassa!
        </Typography>
      </>
    ),
  },
  {
    label: "Kiinteistöt",
    content: (
      <>
        <Typography variant="h5" gutterBottom>
          Kiinteistöt
        </Typography>

        <ExpandableImage
          src="/static/img/docs/kiinteistot_form.jpg"
          alt="Päänäkymä"
        />
        <Typography paragraph>
          Kiinteistösivun näkymä mahdollistaa kiinteistön tietojen hallinnan
          (lisäämisen ja muokkaamisen) sekä sen yksiköinnin. Yksiköinnin avulla
          arvioidaan teiden ylläpitoon liittyviä kustannuksia ja lasketaan eri
          kiinteistöjen osuudet ylläpitokuluista. Yksiköintilaskurin käyttö on
          veloituksetonta rekisteröityneille käyttäjille.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Aloita käyttö
        </Typography>
        <ul>
          <li>Järjestelmässä on kaksi yksiköintitapaa:</li>
          <li>
            <b>Helppo tila (perustila)</b> – soveltuu, kun kiinteistöllä on vain
            yksi yksikköarvo
          </li>
          <li>
            <b>Edistynyt tila (laajennettu yksiköinti)</b> – mahdollistaa
            useiden yksiköintirivien ja käyttömaksujen määrittelyn
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          1. Kiinteistön tiedot
        </Typography>
        <ul>
          <li>
            Avaa lomakenäkymä välilehdeltä <b>“Lisää lomakkeella”</b> tai{" "}
            <b>“Muokkaa lomakkeella”</b>
          </li>
        </ul>
        <ExpandableImage
          src="/static/img/docs/kiinteistot_form.jpg"
          alt="Päänäkymä"
        />

        <Typography variant="subtitle1" gutterBottom>
          1.1 Perustiedot
        </Typography>
        <ul>
          <li>
            <b>Nimi</b> – Kiinteistön nimi (pakollinen)
          </li>
          <li>
            <b>Kiinteistötunnus</b> – Muodossa 123-456-7-89
          </li>
          <li>
            → Kun tunnus syötetään ja kenttä poistetaan, järjestelmä hakee
            sijainnin ja laskee pinta-alan automaattisesti
          </li>
          <li>
            <b>Pinta-ala</b> – Lasketaan automaattisesti kiinteistötunnuksen
            perusteella (m² tai ha)
          </li>
          <li>
            <b>Osakas</b> – Valitse kiinteistön omistaja tai käyttäjä
          </li>
          <li>
            <b>Yksiköinti</b> – Valitse yksiköintitila (helppo / edistynyt)
          </li>
          <li>
            💡 <i>Vinkki:</i> Jos kiinteistötunnusta ei tunnisteta, tarkista sen
            muoto. Jokaisen osan tulee sisältää 1–3 numeroa ja ne erotetaan
            väliviivoin (esim. 123-45-6-78)
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          2. Välilehdet ja navigointi
        </Typography>
        <ul>
          <li>Järjestelmässä on kolme välilehteä:</li>
          <li>
            <b>Lisää/Muokkaa lomakkeella</b>
          </li>
          <li>
            <b>Lisää/Näytä kartalla</b>
          </li>
          <li>
            <b>Yksiköinti</b>
          </li>
        </ul>

        <Typography variant="subtitle1" gutterBottom>
          2.1 Kartta ja Yksiköinti -välilehdet
        </Typography>
        <ul>
          <li>
            Siirtyminen Kartta– ja Yksiköinti-välilehdille on estetty, kunnes
            kiinteistölle on syötetty kelvollinen kiinteistötunnus
          </li>
          <li>
            Jos tunnusta ei ole haettu, saat ilmoituksen:{" "}
            <i>
              “Kiinteistötunnus puuttuu. Hae kiinteistötunnus ennen jatkamista.”
            </i>
          </li>
        </ul>
      </>
    ),
  },
  {
    label: "Yksiköinti ja liikennelajit",
    content: (
      <>
        <Typography variant="h5" gutterBottom>
          Yksiköinti ja liikennelajit
        </Typography>

        <ExpandableImage
          src="/static/img/docs/tieyksikkölaskuri_helppo.png"
          alt="Päänäkymä"
        />

        <Typography variant="h6" gutterBottom>
          1.1 Helppo tila
        </Typography>
        <ul>
          <li>
            Syötä yksi arvo kenttään <b>“Yksiköt”</b>, joka kuvaa kiinteistön
            yksikkömäärää
          </li>
          <li>
            Esimerkiksi: <i>1000</i>
          </li>
          <li>
            Paina <b>Tallenna</b>
          </li>
          <li>
            Yksiköinti tallentuu automaattisesti MUU-liikennelajina (yleinen
            liikenne)
          </li>
          <li>Soveltuu tilanteisiin, joissa tarkempaa laskentaa ei tarvita</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          1.2 Edistynyt tila
        </Typography>
        <ul>
          <li>
            Mahdollistaa useiden yksiköintirivien määrittelyn eri
            liikennetyypeille
          </li>
          <li>
            Valitse <b>“Edistynyt”</b> yksiköintivalitsimesta
          </li>
          <li>
            Jos palaat helppoon tilaan, ohjelma pyytää vahvistuksen, koska
            aiemmat rivit poistuvat
          </li>
          <li>
            ⚠️ Edistynyt tila vaatii voimassa olevan kiinteistötunnuksen ja
            haetun geometrian
          </li>
        </ul>

        <Typography variant="h5" gutterBottom>
          2. Yksiköintinäkymä
        </Typography>

        <Typography variant="h6" gutterBottom>
          2.1 Kartta
        </Typography>
        <ul>
          <li>
            Edistynyt tila sisältää karttanäkymän kiinteistön sijainnin
            tarkasteluun
          </li>
          <li>Kartalla voi mitata tien pituutta ja pinta-alaa</li>
          <li>
            Alareunassa “Laajenna”/“Pienennä”-painike kartan korkeuden
            säätämiseen
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          2.2 Yksiköintirivit
        </Typography>

        <ExpandableImage
          src="/static/img/docs/tieyksikkölaskuri.png"
          alt="Päänäkymä"
        />

        <ul>
          <li>
            Jokainen rivi vastaa yhtä laskentakohdetta (esim. asuinrakennus,
            pelto, metsä)
          </li>
          <li>Kentät:</li>
          <ul>
            <li>
              <b>Liikennelaji</b> – Valitse tyyppi (ULA, ULL, SLV, MeL, MUU,
              Käyttömaksu)
            </li>
            <li>
              <b>Hehtaarikerroin</b> – Käytetään maa-alueille
            </li>
            <li>
              <b>Liikennelajin painokerroin</b> – Valitaan automaattisesti
            </li>
            <li>
              <b>Korjauskerroin (%)</b> – Käyttäjän asettama (yleensä 100 %)
            </li>
            <li>
              <b>Matka (km)</b> – Keskimääräinen etäisyys
            </li>
            <li>
              <b>Matkojen lukumäärä</b> – Vain MUU-liikenteelle
            </li>
            <li>
              <b>Ajoneuvon paino</b> – Vain MUU-liikenteelle
            </li>
            <li>
              <b>Hyötykuorma</b> – Vain MUU-liikenteelle
            </li>
            <li>
              <b>Käyttömaksu (€)</b> – Jos liikennelaji on “Käyttömaksu”
            </li>
            <li>
              <b>Kommentit</b> – Vapaamuotoinen selite
            </li>
            <li>
              <b>Painoluku (tKm)</b> – Laskennallinen arvo
            </li>
          </ul>
        </ul>

        <Typography variant="h6" gutterBottom>
          2.3 Rivien hallinta
        </Typography>
        <ul>
          <li>
            <b>Lisää rivi</b>: Paina “Lisää yksiköinti”
          </li>
          <li>
            <b>Poista rivi</b>: Paina roskakorikuvaketta rivin oikeassa reunassa
          </li>
          <li>Vähintään yksi rivi on säilytettävä</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          2.4 Laskennat
        </Typography>
        <ul>
          <li>Tonnikilometrit lasketaan kaavoilla:</li>
          <ul>
            <li>
              <b>Tonnikilometrit</b> = Hehtaarikerroin × Liikennepainokerroin ×
              Painokerroin × Etäisyys
            </li>
            <li>
              <b>Tonnikilometrit (Muu)</b> = (Matkat × Ajoneuvopaino + Matkat ×
              Kuorma) × Etäisyys
            </li>
          </ul>
        </ul>

        <Typography variant="h6" gutterBottom>
          Esimerkkejä yksikön laskemisesta
        </Typography>

        <ul>
          <li>
            <b>Esimerkki 1: Asuinrakennus</b>
            <br />
            Kiinteistöllä sijaitsee asuinrakennus, jota käytetään
            ympärivuotisesti. Rakennuksen ja pääkadun välinen etäisyys on tasan
            yksi kilometri, ja asukkaat käyttävät tietä säännöllisesti
            esimerkiksi päivittäisiin työ- ja asiointimatkoihin.
          </li>
          <li>
            <b>Esimerkki 2: Maatila</b>
            <br />
            Osa kiinteistöstä on viljeltyä maatilaa. Maatilalla harjoitetaan
            kasvintuotantoa ja mahdollisesti karjataloutta. Kiinteistön liikenne
            koostuu pääosin maatalouskoneiden liikkeistä, kuten
            traktoriliikenteestä pelloilla ja rakennusten välillä, sekä
            mahdollisesti tilan tuotteiden kuljetuksista.
          </li>
          <li>
            <b>Esimerkki 3: Soramonttu</b>
            <br />
            Maatilan yhteydessä on soramonttu, josta ajetaan soraa
            säännöllisesti. Kuljetuksiin käytetään kuorma-autoa, ja liikkeet
            tapahtuvat yleensä tilan ja vastaanottopisteen välillä. Soramontun
            kuljetukset muodostavat merkittävän osan kiinteistön raskaan
            liikenteen määrästä.
            <br />
            <br />
            <b>Laskelman vaiheet:</b>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Laskelman vaihe</b>
                  </TableCell>
                  <TableCell>
                    <b>Laskutoimitus</b>
                  </TableCell>
                  <TableCell>
                    <b>Tulos</b>
                  </TableCell>
                  <TableCell>
                    <b>Selitys</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>Soran kokonaispaino</TableCell>
                  <TableCell>300 m³ × 1,6 t/m³</TableCell>
                  <TableCell>480 tonnia</TableCell>
                  <TableCell>
                    Vuoden aikana kuljetettavan soran kokonaispaino
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Täysiä kuormia</TableCell>
                  <TableCell>480 t ÷ 20 t/kuorma</TableCell>
                  <TableCell>24 kuormaa</TableCell>
                  <TableCell>
                    Kuorma-autolla tehtävien täysien kuljetusten määrä
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Kuljetusten kokonaispaino</TableCell>
                  <TableCell>24 × 15 t + 24 × 35 t</TableCell>
                  <TableCell>1200 tonnia</TableCell>
                  <TableCell>
                    Ajoneuvon ja kuorman paino edestakaisilla matkoilla koko
                    vuoden aikana
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </li>
        </ul>

        <Typography paragraph>
          Näkymän alareunassa näkyy automaattisesti:
        </Typography>
        <ul>
          <li>
            <b>Yksiköinnit yhteensä (tKm)</b> – kaikkien rivien painolukujen
            summa
          </li>
          <li>
            <b>Käyttömaksut yhteensä (€)</b> – kaikkien “Käyttömaksu”-rivien
            euromääräinen summa
          </li>
        </ul>

        <Typography variant="h5" gutterBottom>
          3. Liikennelajit ja ohjearvot (2023)
        </Typography>
        <ul>
          <li>
            <b>ULA</b> – Asuinkiinteistö: 1700 tKm
          </li>
          <li>
            <b>ULL</b> – Lomamökki / kesämökki: 1300 / 750 / 350 tKm
          </li>
          <li>
            <b>SLV</b> – Peltoalueet ja karjatalous: 60 / 130 tKm
          </li>
          <li>
            <b>MeL</b> – Metsäalueet: 21 / 18 / 11 / 7 / 3 tKm
          </li>
          <li>
            <b>MUU</b> – Muuliikenne: käyttäjän määriteltävä
          </li>
          <li>
            <b>Käyttömaksu</b> – Euromääräinen: käyttäjän määriteltävä
          </li>
        </ul>
        <Typography paragraph>
          💡 Arvoja voi käyttää sellaisenaan tai säätää korjauskertoimilla ja
          matka-arvoilla tilanteen mukaan.
        </Typography>

        <Typography variant="subtitle1" gutterBottom>
          ULL – Lomamökki / kesämökki
        </Typography>
        <ul>
          <li>
            <b>ULL 1300</b> – ympärivuotinen käyttö
          </li>
          <li>
            <b>ULL 750</b> – kesäkauden käyttö
          </li>
          <li>
            <b>ULL 350</b> – satunnainen käyttö
          </li>
        </ul>

        <Typography variant="subtitle1" gutterBottom>
          SLV – Peltoalueet ja karjatalous
        </Typography>
        <ul>
          <li>
            <b>SLV 60</b> – kasvinviljelytila
          </li>
          <li>
            <b>SLV 130</b> – nautakarjatila
          </li>
        </ul>
        <Typography variant="subtitle1" gutterBottom>
          Metsäalueet
        </Typography>
        <ExpandableImage
          src="/static/img/docs/metsa-alueet.png"
          alt="Päänäkymä"
        />
      </>
    ),
  },
  {
    label: "Tilikaudet",
    content: (
      <>
        <Typography variant="h5" gutterBottom>
          Tilikaudet – Tilikausien hallinta
        </Typography>
        <Typography paragraph>
          Tilikaudet-näkymä on osa taloushallintoa, ja sillä hallitaan tiekunnan
          eri kirjanpitokausia. Vain aktiivinen (Auki) tilikausi mahdollistaa
          uusien kirjanpitotapahtumien ja laskujen luomisen.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Navigointi ja yleisnäkymä
        </Typography>
        <ul>
          <li>Murupolku: Etusivu → Talous → Tilikaudet.</li>
          <li>Sivun yläosassa näet otsikon ja murupolun navigointia varten.</li>
          <li>
            Listaus: Näkymä näyttää taulukon olemassa olevista tilikausista,
            joissa on tiedot alku- ja loppupäivämääristä sekä tilasta.
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          2. Toiminnot
        </Typography>
        <ul>
          <li>
            Lisää tilikausi: Paina oikeassa yläkulmassa olevaa
            "Lisää"-painiketta. Tämä avaa Tilikausilomakkeen luontitilaan.
          </li>
          <li>
            Muokkaa: Tilikausilistan "Toiminnot"-sarakkeessa on:
            <br />
            &emsp;• ✏️ (Kynä): Siirry tilikauden muokkaustilaan.
          </li>
          <li>
            Poista:
            <br />
            &emsp;• 🗑️ (Roskakori): Poista tilikausi. Toistaiseksi
            poisto-ominaisuus ei ole käytettävissä
          </li>
          <li>
            Tarkastele: Näkymässä on myös 🔍 (Suurennuslasi) -kuvake, joka
            siirtää lomakkeelle erilliseen lukutilaan.
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          3. Tilatieto ja lataus
        </Typography>
        <ul>
          <li>
            Jos tilikaudet lataavat tietoja, näytetään latausindikaattori
            (pyörivä kuvake).
          </li>
          <li>
            Jos tilikausia ei ole luotu, näytetään ilmoitus "Ei tilikausia".
          </li>
          <li>
            Toimintojen (lisäys, muokkaus) onnistumisesta tai epäonnistumisesta
            ilmoitetaan sivun alareunassa näkyvällä ilmoituspalkilla.
          </li>
        </ul>

        <Typography variant="h5" gutterBottom>
          Tilikausilomake – Tilikauden luominen ja muokkaus
        </Typography>
        <Typography paragraph>
          Tällä lomakkeella määritellään uuden tilikauden alkamis- ja
          päättymispäivämäärät sekä sen aktiivisuustila.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Tilikauden päivämäärät
        </Typography>
        <ul>
          <li>Alkaen : Valitse tilikauden alkamispäivämäärä.</li>
          <li>Päättyy : Valitse tilikauden päättymispäivämäärä.</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          2. Tilikauden tila
        </Typography>
        <ul>
          <li>
            Avoin: Tilikausi on aktiivinen, ja siihen voidaan luoda uusia
            kirjanpitotapahtumia. Tämä on lomakkeella oletusarvo uusille
            kausille.
          </li>
          <li>
            Suljettu: Tilikausi on päättynyt, eikä siihen voida enää lisätä
            kirjanpitotapahtumia. (Huom: Suljettu-vaihtoehto on pois käytöstä
            uutta tilikautta luotaessa, ja se tulee valittavaksi vain olemassa
            olevaa tilikautta muokatessa. Koodin perusteella se on valittavissa
            vain, jos tilikausi on jo olemassa.)
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          3. Tallennus ja peruminen
        </Typography>
        <ul>
          <li>
            Tallenna: Tallentaa uuden tilikauden tiedot tai päivittää olemassa
            olevan tilikauden. Tämän jälkeen lomake sulkeutuu ja palaat
            tilikausilistaukseen.
          </li>
          <li>
            Peruuta: Sulkee lomakkeen ja palaa tilikausilistaukseen
            tallentamatta muutoksia.
          </li>
        </ul>
      </>
    ),
  },

  {
    label: "Tositteet",
    content: (
      <>
        <Typography variant="h5" gutterBottom>
          Tositteet – Kirjanpitotositteiden hallinta
        </Typography>
        <Typography paragraph>
          Tositteet-näkymä on taloushallinnon keskeinen sivu, jolla voit
          tarkastella, lisätä ja hallita kaikkia tiekunnan kirjanpitotositteita.
          Kaikki tapahtumat, kuten maksuunpanot ja muut kirjanpitomerkinnät,
          tallennetaan tositteina.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Navigointi ja yleisnäkymä
        </Typography>
        <ul>
          <li>Murupolku: Etusivu → Talous → Tositteet.</li>
          <li>Sivun yläosassa näet otsikon ja murupolun navigointia varten.</li>
          <li>
            Listaus: Näkymä näyttää taulukon olemassa olevista tositteista,
            joissa on tiedot kuvauksesta ja päivämäärästä.
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          2. Aikavälin rajaus (Tilikausi)
        </Typography>
        <ul>
          <li>
            Tositelistaus on oletuksena rajattu aktiivisen tilikauden mukaisesti
            (Alkaen / Päättyy -kentät).
          </li>
          <li>
            Aikarajatut listaukset seuraavat automaattisesti aktiivista
            tilikautta. Huomioithan, ettei aikarajausta pysty käyttämään, jos
            käynnissä olevalla tilikaudella ei ole kirjattuna tositteita.
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          3. Toiminnot
        </Typography>
        <ul>
          <li>
            Lisää tosite: Paina oikeassa yläkulmassa olevaa "Lisää"-painiketta.
            Tämä avaa tositelomakkeen luontitilaan.
          </li>
          <li>
            Tarkastele / Muokkaa / Poista: Tositelistan "Toiminnot"-sarakkeessa
            on kolme kuvaketta:
            <br />
            &emsp;• 🔍 (Suurennuslasi): Siirry tositteen lukutilaan , jossa näet
            tiedot mutta et voi muokata.
            <br />
            &emsp;• ✏️ (Kynä): Siirry tositteen muokkaustilaan .
            <br />
            &emsp;• 🗑️ (Roskakori): Poista tosite. Poisto vaatii erillisen
            varmistuksen ponnahdusikkunassa.
          </li>
        </ul>

        <Typography variant="h5" gutterBottom>
          Tositelomake – Uuden tositteen luominen ja muokkaus
        </Typography>
        <Typography paragraph>
          Tositelomakkeella luot uuden kirjanpitotositteen tai muokkaat olemassa
          olevaa. Kirjanpitotositteen on oltava tasapainossa; debetin ja
          creditin kokonaissummien on vastattava toisiaan.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Tositteen perustiedot
        </Typography>
        <ul>
          <li>Nimi: Anna tositteelle kuvaava nimi. Pakollinen tieto.</li>
          <li>Päivämäärä: Valitse tositteen päivämäärä (pakollinen tieto).</li>
        </ul>

        <Typography variant="h6" gutterBottom>
          2. Tapahtumat (Transactions)
        </Typography>
        <Typography paragraph>
          Tämä on tositteen ydin, johon merkitään kirjanpitotapahtumat. Voit
          lisätä useita tapahtumarivejä.
        </Typography>
        <ul>
          <li>Kuvaus: Tapahtuman tarkempi kuvaus. Pakollinen.</li>
          <li>
            Debet: Merkitään tilin lisäys (esim. pankkitiliin rahaa sisään) tai
            meno/kuluerä. Summan on oltava positiivinen.
          </li>
          <li>
            Credit: Merkitään tilin vähennys (esim. pankkitililtä rahaa ulos)
            tai tuotto/velka. Summan on oltava positiivinen.
          </li>
          <li>
            Tili: Valitse oikea tilikoodi pudotusvalikosta (esim. 190 –
            Pankkitili, 400 – Lanaus). Pakollinen.
          </li>
          <li>
            Lisää / Poista tapahtuma: Paina "+ Lisää tapahtuma" lisätäksesi
            uuden rivin tai "x"-kuvaketta rivin poistamiseksi.
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          3. Tallennus ja peruminen
        </Typography>
        <ul>
          <li>
            Lähetä: Tallenna tosite. Järjestelmä tarkistaa, että tosite on
            tasapainossa (Debet- ja Credit-sarakkeiden summat täsmäävät) ja että
            kaikki pakolliset kentät on täytetty.
          </li>
          <li>
            Peruuta: Palaa tositteiden päänäkymään tallentamatta muutoksia.
          </li>
          <li>
            Tarkastelutila: Kun tosite avataan lukutilassa, kaikki syöttökentät
            ja painikkeet ovat pois käytöstä.
          </li>
          <li>
            Tarkista aina, että Debet ja Credit ovat yhtä suuret ennen
            tallennusta!
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          Virhe- ja validoinnit
        </Typography>
        <ul>
          <li>
            Kentät "Debet" ja "Credit" hyväksyvät vain positiivisia lukuja
            (desimaalierottimena voi käyttää joko pilkkua tai pistettä).
          </li>
          <li>
            Jos tallennuksessa ilmenee virheitä (esim. pakolliset tiedot
            puuttuvat tai numeromuoto on virheellinen), näytetään virheilmoitus.
          </li>
        </ul>
      </>
    ),
  },

  {
    label: "Yhteys – Yhteydenotto ylläpitoon",
    content: (
      <>
        <Typography variant="h5" gutterBottom>
          Yhteys – Viestin lähettäminen ylläpidolle
        </Typography>
        <Typography paragraph>
          Yhteys-näkymän kautta käyttäjä voi lähettää viestin suoraan
          sovelluksen ylläpidolle. Viesti aloittaa uuden keskustelun, jonka
          etenemistä pystyt seuraamaan keskustelut -näkymässä.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Käyttöliittymä ja Lomake
        </Typography>
        <Typography paragraph>
          Sivu sisältää yksinkertaisen lomakkeen, joka on suunnattu viestin
          lähettämiseen.
        </Typography>
        <ul>
          <li>
            Viestikenttä: Pakollinen kenttä, jossa käyttäjä kirjoittaa viestin.
          </li>
          <li>Lähetä-painike: Käynnistää viestin lähetyksen.</li>
          <li>Peruuta-painike: Tyhjentää viestikentän.</li>
        </ul>
      </>
    ),
  },

  {
    label: "Kokous – Hallinta, Kutsu ja Pöytäkirja",
    content: (
      <>
        <Typography variant="h5" gutterBottom>
          Kokoukset – Tapaamisten hallinta ja arkistointi
        </Typography>
        <ExpandableImage src="/static/img/docs/kokous.jpg" alt="Päänäkymä" />
        <Typography paragraph>
          Kokoukset-moduulilla hoidetaan yhdistyksen tai tiekunnan tapaamisten
          elinkaari: kutsusta pöytäkirjan arkistointiin. Moduuli sisältää
          reaaliaikaisen seurantamekanismin sähköpostikutsuille.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Kokouksen luonti ja muokkaus
        </Typography>
        <Typography paragraph>
          Lomakkeella määritellään kokouksen perusasiat.
        </Typography>
        <ul>
          <li>
            Luo/Muokkaa: Määrittele Aihe, Päivämäärä/Aika, Tyyppi (esimerkiksi
            Vuosikokous) ja Paikka.
          </li>
          <li>
            Esityslista: Käytä esitäytettyä pohjaa tai muokkaa esityslistan
            pykäliä suoraan tekstikentässä.
          </li>
          <li>
            Tallennus ja Kutsut: "Tallenna ja luo kutsu" -painike avaa
            Kokouskutsut-välilehden ja jossa käyttäjä pystyy käynnistämään
            kutsujen lähetyksen välittömästi.
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          2. Kokouskutsut-välilehti
        </Typography>
        <ExpandableImage
          src="/static/img/docs/kokouskutsut.jpg"
          alt="Päänäkymä"
        />
        <Typography paragraph>
          Kun kokous on tallennettu, Kokouskutsut-välilehti aktivoituu. Tällä
          välilehdellä käyttäjä pystyy seuraamaan vastaanottajakohtaisesti
          lähetettyjä kutsuja. Viestien/kutsujen käsittelyä voidaan seurata
          reaaliaikaisesti.
        </Typography>
        <ul>
          <li>
            Kutsujen Lähetys: Lähetys aloitetaan toiminnolla, joka käsittelee
            kaikki osakkeenomistajat. Järjestelmä luo kutsun PDF:n ja asettaa
            kutsun jonoon (Tila: 'Jonossa').
          </li>
          <li>
            Toimitustavan Valinta: Kutsumistapa (Sähköposti / Kirje) määräytyy
            automaattisesti osakkeenomistajan laskun toimitustavan mukaan.
          </li>
          <li>
            Reaaliaikainen Tila: Taulukko päivittyy reaaliajassa näyttäen tarkan
            tilan: 'Luodaan PDF:ää', 'Lähetetään (sähköposti)', 'Lähetetään
            (kirje)' tai 'Lähetetty'. Epäonnistumiset raportoidaan punaisella
            tunnisteella.
          </li>
          <li>
            Tiedostonhallinta: Kun kutsun PDF on luotu, Lataa (⬇️) ja Esikatselu
            (🔍) -kuvakkeet aktivoituvat rivillä, mahdollistaen kutsun
            tarkastelun ennen tai jälkeen lähetyksen.
          </li>
          <li>
            Loppuunsaattaminen: Kun kaikki kutsut on käsitelty, taulukkoon
            kirjataan lopullinen lähetyspäivämäärä.
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          3. Kokousten listaus
        </Typography>
        <Typography paragraph>
          Päänäkymä näyttää listan kaikista tallennetuista kokouksista.
        </Typography>
        <ul>
          <li>
            Lajittelu: Listaa voi lajitella Aiheen tai Päivämäärän mukaan
            klikkaamalla sarakkeen otsikkoa.
          </li>
          <li>
            Toiminnot: Muokkaa (✏️) avaa lomakkeen, Poista (🗑️) mahdollistaa
            kokouksen poistamisen.
          </li>
        </ul>
      </>
    ),
  },
  {
    label: "Tiedostot",
    content: (
      <>
        <Typography variant="h5" gutterBottom>
          Tiedostot – Dokumenttien hallinta
        </Typography>

        <ExpandableImage src="/static/img/docs/tiedostot.jpg" alt="Päänäkymä" />
        <Typography paragraph>
          Tiedostot-näkymä tarjoaa keskitetyn paikan tiekunnan tai yhdistyksen
          dokumenttien lataamiseen, tallentamiseen, selaamiseen ja hallintaan.
          Tiedostot liittyvät aina kirjautuneen käyttäjän aktiiviseen
          yhdistykseen/tiekuntaan.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Tiedostojen listaus
        </Typography>
        <Typography paragraph>
          Taulukko näyttää listan tallennetuista tiedostoista, joissa on
          seuraavat tiedot:
        </Typography>
        <ul>
          <li>Nimi: Tiedoston alkuperäinen nimi.</li>
          <li>Tyyppi: Tiedoston MIME-tyyppi.</li>
          <li>
            Koko (mb): Tiedoston koko megatavuina, kahden desimaalin
            tarkkuudella.
          </li>
          <li>Luotu: Tiedoston tallennusaika järjestelmään .</li>
          <li>Toiminnot: Lataus, esikatselu ja poisto.</li>
        </ul>
        <Typography paragraph>
          Jos tiedostoja ei ole, näytetään viesti "Ei tiedostoja".
        </Typography>

        <Typography variant="h6" gutterBottom>
          2. Toiminnot
        </Typography>
        <ul>
          <li>
            Lisää (Lataus):
            <br />
            &emsp;• "Lisää"-painike avaa selaimesi tiedostonvalintaikkunan.
            <br />
            &emsp;• Valittu tiedosto lähetetään palvelimelle ja tallennetaan
            aktiivisena olevalle tiekunnalle.
            <br />
            &emsp;• Latauksen aikana näkyy pyörivä latausindikaattori ja
            "Lisää"-painike on pois käytöstä.
          </li>
          <li>
            Lataa:
            <br />
            &emsp;• ⬇️ (Latauskuvake): Käynnistää tiedoston lataamisen selaimeen
            suoraan palvelimelta.
          </li>
          <li>
            Esikatselu:
            <br />
            &emsp;• 🔍 : Avaa tiedoston esikatselutilaan erilliseen
            modaali-ikkunaan.
          </li>
        </ul>
      </>
    ),
  },

  {
    label: "Karttanäkymä",
    content: (
      <>
        <Typography variant="h5" gutterBottom>
          🗺️ Karttanäkymä – Piirto, Kiinteistöt ja Kohteet
        </Typography>

        <ExpandableImage src="/static/img/docs/kartta.jpg" alt="Päänäkymä" />
        <Typography paragraph>
          Karttanäkymä on sovelluksen keskeinen työkalu kiinteistöalueiden ja
          kiinnostavien kohteiden (POI) hallintaan. Sen avulla voidaan piirtää
          alueita, lisätä kiinteistöjä sekä tarkastella tai muokata
          tallennettuja kohteita.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Kartan perustoiminnot
        </Typography>
        <ul>
          <li>
            <strong>Piirtotila:</strong> Käyttäjä voi piirtää <em>viivoja</em>,
            <em>polygoneja</em> tai <em>pisteitä</em> kartalle.
          </li>
          <li>
            <strong>Zoomaus ja siirto:</strong> Karttaa voi lähentää, loitontaa
            ja siirtää vapaasti.
          </li>
          <li>
            <strong>Lisäystila:</strong> Tukee useiden kiinteistöjen lisäämistä
            esimerkiksi uutta tiekuntaa luotaessa.
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          2. Piirto ja kiinteistöhallinta
        </Typography>
        <ul>
          <li>
            <strong>Piirtotyökalut:</strong> Työkalupaneelista voi vaihtaa
            piirtotilan (viiva, polygoni, piste) tai palata valintatilaan.
          </li>
          <li>
            <strong>Poisto:</strong> Valitut geometriat voi poistaa suoraan
            kartalta.
          </li>
          <li>
            <strong>Kiinteistön lisäys:</strong> Kun polygoni on valittu,
            avautuu ikkuna kiinteistön tietojen syöttöä varten. Avautunut ikkuna
            sisältää kiinteistöjen tai teiden lisäämiseen tarvittavat kentät
            sekä poistamis- ja lisäämispainikkeet.
          </li>
        </ul>
      </>
    ),
  },
];
